import { render, staticRenderFns } from "./index.vue?vue&type=template&id=370ff2f2&scoped=true&lang=html&"
import script from "./customSingularGoodsList.js?vue&type=script&lang=js&"
export * from "./customSingularGoodsList.js?vue&type=script&lang=js&"
import style0 from "./customSingularGoodsList.styl?vue&type=style&index=0&id=370ff2f2&lang=stylus&scoped=true&"
import style1 from "./resetStyle.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370ff2f2",
  null
  
)

export default component.exports